"use strict";
var appn;
(function (appn) {
    var iframe;
    (function (iframe) {
        var _isHost = false;
        var iframeHost = {
            reloadFlag: false,
            setModalIframeHeight: function (preventHeightCollapse) {
                var _a, _b, _c;
                let $iframe = $('#e-modal-iframe');
                if (preventHeightCollapse) {
                    let currentHeight = $iframe.height();
                    $iframe[0].style.height = '0px';
                    let targetHeight = (_c = (_b = (_a = $iframe[0]) === null || _a === void 0 ? void 0 : _a.contentWindow) === null || _b === void 0 ? void 0 : _b.document.documentElement.scrollHeight) !== null && _c !== void 0 ? _c : 0;
                    $iframe[0].style.height = currentHeight + 'px';
                    $iframe.animate({ height: targetHeight + 'px' });
                }
                else {
                    $iframe[0].style.height = 'auto';
                    if ($iframe[0].contentWindow !== null)
                        $iframe.animate({ height: $iframe[0].contentWindow.document.documentElement.scrollHeight + 'px' });
                }
            },
            setModalContent: function ($content) {
                var newHeader = $content.find('.modal-header');
                if (newHeader.length !== 0)
                    this.setModalHeader(newHeader);
                var newTitle = $content.find('.modal-title');
                if (newTitle.length !== 0)
                    setModalTitle(newTitle);
                var $newToolbar = $content.find('.modal-toolbar');
                if ($newToolbar.length !== 0)
                    setModalToolbar($newToolbar);
                var newFooter = $content.find('.modal-footer');
                if (newFooter.length !== 0)
                    setModalFooter(newFooter);
            },
            setModalHeader: function ($header) {
                var $dialog = $('#e-modal-dialog');
                var currentHeader = $dialog.find('.modal-header');
                currentHeader.replaceWith($header);
            },
            setModalTitle: function ($title) {
                var $dialog = $('#e-modal-dialog');
                var currentTitle = $dialog.find('.modal-title');
                currentTitle.replaceWith($title);
            },
            setModalToolbar: function ($toolbar) {
                var $dialog = $('#e-modal-dialog');
                var $currentToolbar = $dialog.find('.modal-toolbar');
                $currentToolbar.replaceWith($toolbar);
            },
            setModalFooter: function ($footer) {
                var $dialog = $('#e-modal-dialog');
                var content = $dialog.find('.modal-content');
                var currentFooter = $dialog.find('.modal-footer');
                if (currentFooter.length === 0)
                    content.append($footer);
                else
                    currentFooter.replaceWith($footer);
            },
            startLoader: function () {
                appn.dialog.showLoading();
            },
            stopLoader: function () {
                appn.dialog.hideLoading();
            },
            closeModal: function () {
                $('#e-modal').modal('hide');
            },
            setModalSizeClass: function (sizeClass) {
                if (sizeClass === null || sizeClass === undefined || sizeClass.length === 0)
                    return;
                $('#e-modal-dialog').addClass(sizeClass);
            }
        };
        function init() {
            if (window.parent === window) {
                _isHost = true;
                window.appnHost = iframeHost;
                initHost();
            }
            else
                initClient();
        }
        iframe.init = init;
        function initHost() {
            $(document).on('click', '[data-modal-iframe]', function (e) {
                $('.modal').modal('hide');
                var data = $(this).data();
                e.preventDefault();
                openModal(data);
            });
        }
        function getHost() {
            var win = _isHost ? window : parent;
            return win.appnHost;
        }
        iframe.getHost = getHost;
        function initClient() {
            var _a;
            $('body').attr('id', 'appn-iframe-modal-body');
            $('body')
                .css('padding-right', '18px')
                .css('padding-left', '18px')
                .css('padding-top', '3px')
                .css('padding-bottom', '3px');
            var $modaliframeData = $('#modal-data');
            if ($modaliframeData.length != 0) {
                loadModalData($modaliframeData);
            }
            (_a = getHost()) === null || _a === void 0 ? void 0 : _a.stopLoader();
            $('select:not(.select2-skipheight)').each(function () {
                $(this).on('select2:open', function () {
                    select2SetHeight();
                });
                $(this).on('select2:close', function () {
                    select2SetHeight();
                });
            });
            $('.datepicker').on('dp.show dp.hide', function () {
                appn.ui.handleParentResize(0, 15);
            });
            $('#notifications-tabs a.nav-link').on('shown.bs.tab', function () {
                appn.ui.handleParentResize(0, 50);
            });
            $('#notifications-tabs button.dismiss-selected').on('click', function () {
                appn.ui.handleParentResize(0, 0);
            });
            $('#locatebtn').on('click', function () {
                appn.ui.handleParentResize(290, 0);
            });
            $('.addRow.btn').on('click', function () {
                appn.ui.handleParentResize(0, 0);
            });
            $('.notification-parent').click(function (event) {
                $('#btnNotificationsOptions .dropdown-menu').dropdown('hide');
                var element = event.currentTarget;
                setTimeout(function () {
                    element.scrollIntoView({
                        behavior: "auto",
                        block: "center"
                    });
                }, 5);
            });
            $('#btnNotificationsOptions .btn.btn-tool:not(.btn-refresh)').on('click', function () {
                var $iframe = parent.document.getElementById('e-modal-iframe');
                if ($iframe === null)
                    return;
                var iframeHeight = $iframe.offsetHeight;
                if ($('#btnNotificationsOptions').hasClass('show') || iframeHeight > 275)
                    appn.ui.handleParentResize(0, 50);
                else
                    $iframe.style.height = '275px';
            });
            $('#updatedAttachFile').on('change', function () {
                appn.ui.handleParentResize(10, 0);
            });
            var textAreaResize = function (selector) {
                $(selector).on('mousedown', function () {
                    var resizeInt = setInterval(() => appn.ui.handleParentResize(0, 0), 1000 / 15);
                    $(window).on('mouseup', function () {
                        if (resizeInt !== null) {
                            clearInterval(resizeInt);
                            appn.ui.handleParentResize(0, 0);
                        }
                    });
                });
            };
            textAreaResize('#Answer_Value');
        }
        $(document).on('keyup', ".bootstrap-duallistbox-container .filter", function () {
            $(this).blur();
            $(this).focus();
        });
        function loadModalData($modaliframeData) {
            if (parent === window)
                throw new Error('Modal iframe (div#modal-data) data can only live inside the iframe content');
            var host = getHost();
            if (host === undefined)
                throw new Error('#appnEModal is not present on the Host page');
            var modalSize = $modaliframeData.data('e-modal-size');
            host.setModalSizeClass(modalSize);
            if ($modaliframeData.find('[data-submit-type]').length !== 0)
                bindSubmitButtonsAndNavLinks($modaliframeData);
            host.setModalContent($modaliframeData);
            setTimeout(function () {
                host.setModalIframeHeight();
            }, 250);
        }
        function select2SetHeight() {
            var $parentiFrame = parent.document.getElementById('e-modal-iframe');
            setTimeout(function () {
                if ($parentiFrame === null)
                    return;
                $parentiFrame.style.height = 'auto';
                $parentiFrame.style.height = document.documentElement.scrollHeight + 15 + 'px';
            }, 0);
        }
        function openModal(options) {
            return eModal.iframe({
                url: options.modalIframe || options.url,
                size: options.modalSize || options.size || 'modal-lg',
                title: options.modalTitle || options.title || ' ',
                scrolling: options.iframeScrolling || options.scrolling || 'yes',
                iframeHeight: 'auto'
            }).then(function () {
                return $('#e-modal');
            });
        }
        iframe.openModal = openModal;
        function bindSubmitButtonsAndNavLinks($content) {
            var formId = $content.data('form-selector');
            formId = formId || '#appnForm';
            var $form = $(formId);
            var $submitTypeInput = $form.find('[name="submitType"]');
            if ($submitTypeInput.length === 0) {
                $submitTypeInput = $('<input type="hidden" name="submitType"></input>');
                $form.append($submitTypeInput);
            }
            $content.find('[data-submit-type]').click(function (e) {
                e.preventDefault();
                if (!$(this).hasClass('noReload'))
                    getHost().reloadFlag = true;
                if ($(this).data('submitType') === ('Send')) {
                    $form.find('[name="submitType"]').remove();
                    const submitValue = $(this).data('submitType');
                    $form.append(`<input type="hidden" name="submitType" value="${submitValue}" />`);
                }
                else {
                    $submitTypeInput.val($(this).data('submitType'));
                }
                if ($form.valid()) {
                    $form.submit();
                }
            });
            $content.find('.modal-footer a').click(function (e) {
                var _a, _b;
                e.preventDefault();
                (_a = getHost()) === null || _a === void 0 ? void 0 : _a.startLoader();
                window.location.href = (_b = $(this).attr('href')) !== null && _b !== void 0 ? _b : '';
            });
        }
        iframe.bindSubmitButtonsAndNavLinks = bindSubmitButtonsAndNavLinks;
        function startLoader() {
            var _a;
            (_a = getHost()) === null || _a === void 0 ? void 0 : _a.startLoader();
        }
        iframe.startLoader = startLoader;
        function stopLoader() {
            var _a;
            (_a = getHost()) === null || _a === void 0 ? void 0 : _a.stopLoader();
        }
        iframe.stopLoader = stopLoader;
        function setModalIframeHeight(preventHeightCollapse) {
            var _a;
            (_a = getHost()) === null || _a === void 0 ? void 0 : _a.setModalIframeHeight(preventHeightCollapse);
        }
        iframe.setModalIframeHeight = setModalIframeHeight;
        function setModalContent($content) {
            var _a;
            (_a = getHost()) === null || _a === void 0 ? void 0 : _a.setModalContent($content);
        }
        iframe.setModalContent = setModalContent;
        function setModalHeader($header) {
            var _a;
            (_a = getHost()) === null || _a === void 0 ? void 0 : _a.setModalHeader($header);
        }
        iframe.setModalHeader = setModalHeader;
        function setModalTitle($title) {
            var _a;
            (_a = getHost()) === null || _a === void 0 ? void 0 : _a.setModalTitle($title);
        }
        iframe.setModalTitle = setModalTitle;
        function setModalToolbar($toolbar) {
            var _a;
            (_a = getHost()) === null || _a === void 0 ? void 0 : _a.setModalToolbar($toolbar);
        }
        iframe.setModalToolbar = setModalToolbar;
        function setModalFooter($footer) {
            var _a;
            (_a = getHost()) === null || _a === void 0 ? void 0 : _a.setModalFooter($footer);
        }
        iframe.setModalFooter = setModalFooter;
        function setModalSizeClass(sizeClass) {
            var _a;
            (_a = getHost()) === null || _a === void 0 ? void 0 : _a.setModalSizeClass(sizeClass);
        }
        iframe.setModalSizeClass = setModalSizeClass;
        function closeModal() {
            var _a;
            (_a = getHost()) === null || _a === void 0 ? void 0 : _a.closeModal();
        }
        iframe.closeModal = closeModal;
    })(iframe = appn.iframe || (appn.iframe = {}));
})(appn || (appn = {}));
